<template>
  <div
    class="flex items-center gap-5"
    :class="{
      'flex-col sm:flex-row': stackOnMobile,
    }"
  >
    <p
      style="text-wrap: balance"
      class="font-bold mb-0 relative top-4 text-sm lg:text-base w-full"
      :class="{
        'flex-[0_0_70px]': restrictLeftCol,
        [leftLabelClass]: true,
      }"
    >
      {{ label }}
    </p>
    <UProgress size="sm" :value="modelValue" :max="100" :color="barColor">
      <template #indicator="{ percent }">
        <div
          class="text-right text-sm lg:text-base"
          :class="{ [valueLabelClass]: true }"
          :style="{ width: `${percent}%` }"
        >
          {{ percent.toFixed(2) }}%
        </div>
      </template>
    </UProgress>
    <p
      class="font-bold mb-0 relative sm:top-4 text-sm lg:text-base w-full"
      :class="{ 'flex-[0_0_70px]': restrictRightCol, [rightLabelClass]: true }"
    >
      {{ rawValue }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { formatNumber } from '~/lib/helpers/format-number';
type Props = {
  label?: string;
  modelValue: number | string;
  max: number;
  rawValue: string | number;
  leftLabelClass: string;
  rightLabelClass: string;
  valueLabelClass: string;
  restrictLeftCol: boolean;
  restrictRightCol: boolean;
  stackOnMobile: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  restrictLeftCol: true,
  restrictRightCol: true,
  stackOnMobile: false,
  leftLabelClass: 'text-neutral-500 dark:text-white',
  rightLabelClass: 'text-neutral-500 dark:text-white',
  valueLabelClass: 'text-neutral-500 dark:text-white',
});
const emit = defineEmits(['update:modelValue']);
const { modelValue, max } = useVModels(props, emit);
const barColor = computed(() => {
  const val =
    typeof modelValue.value === 'string' ? parseFloat(modelValue.value) : modelValue.value;
  switch (true) {
    case val / max.value < 0.4:
      return 'amulet';
    case val / max.value < 0.8:
      return 'cloud-burst';
    case val / max.value < 0.9:
      return 'fuel-yellow';
    default:
      return 'cardinal';
  }
});
</script>
